import type { TypographyProps as MuiTypographyProps } from "@mui/material";
import { Typography as MuiTypography } from "@mui/material";
import { FC } from "react";

export const Typography: FC<MuiTypographyProps> = ({ children, ...props }) => {
	return <MuiTypography {...props}>{children}</MuiTypography>;
};
